import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Bonus2() {
  const benefits = ['Script 1: Open the case and get routed to the right department instantly', 'Script 2: Get the exact document checklist (so you send it complete the first time)', 'Script 3: Force everything into writing (no more "they told me")', 'Script 4: Escalate to a supervisor without an argument', 'Script 5: Confirm document receipt so nothing "gets lost"', 'Script 6: Handle the vacancy/occupancy question safely', 'Script 7: Use deadline language to trigger urgent action', 'BONUS: A copy/paste Call Log template to document every call', 'BONUS: A 1-page pre-call printable checklist'];
  return <section className="bg-warm-white py-12 md:py-20 px-6 border-b border-gold/20" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 items-center" data-id="element-19">
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-20">
            <img src="https://cdn.magicpatterns.com/uploads/28QsxzFE5Af5nYPKjnRuX7/Bonus_2_image_The_Inherited_House.png" alt="The Bank Call Script Pack" className="w-full max-w-sm object-contain drop-shadow-editorial rounded-lg" data-id="element-21" />
          </div>

          <div className="w-full lg:w-2/3" data-id="element-22">
            <div className="inline-block bg-amber-100 text-amber-800 font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-23">
              BONUS #2
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-2" data-id="element-24">
              The Bank Call Script Pack
            </h2>
            <h3 className="text-xl md:text-2xl text-navy-light font-heading italic mb-2" data-id="element-25">
              "7 Scripts To Make Them Take You Seriously"
            </h3>
            <p className="text-lg text-slate font-medium mb-8" data-id="element-26">
              Value: $9.99 — Yours FREE Today
            </p>

            <div className="space-y-4 text-text-dark font-body text-lg leading-relaxed mb-8" data-id="element-27">
              <p data-id="element-28">
                The first phone call to the bank is where most heirs freeze.
              </p>
              <p data-id="element-29">
                You don't know who to ask for. You don't know what to say. And
                the second you sound unsure — they put you on hold, transfer you
                three times, and you hang up with nothing.
              </p>
              <p data-id="element-30">This Script Pack ends that.</p>
              <p data-id="element-31">
                Inside, you get 7 word-for-word scripts that tell you exactly
                what to say — and exactly how to close each call with a case
                number, a document checklist, and a confirmed next step in
                writing.
              </p>
            </div>

            <h4 className="text-xl font-bold text-navy mb-4" data-id="element-32">
              Here's what's inside:
            </h4>
            <ul className="space-y-3 mb-8" data-id="element-33">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-34">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-35" />
                  <span className="text-text-dark text-lg" data-id="element-36">{benefit}</span>
                </li>)}
            </ul>

            <div className="bg-white p-6 rounded-xl border border-slate-light/20 shadow-sm space-y-4" data-id="element-37">
              <p className="text-text-dark font-body" data-id="element-38">
                <strong className="text-navy" data-id="element-39">Who this is for:</strong> Anyone
                who has avoided calling the bank because they don't know what to
                say.
              </p>
              <p className="text-text-dark font-body" data-id="element-40">
                <strong className="text-navy" data-id="element-41">What it replaces:</strong> 3 hours
                of back-and-forth calls, wrong departments, and vague answers.
              </p>
              <blockquote className="border-l-4 border-gold pl-4 italic text-slate mt-4" data-id="element-42">
                "The scripts gave me the exact words. I went from 'we can't
                speak to you' to 'let me open a case' in one call." — Verified
                reader
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
}